<div class="progress">
  <div class="card">
    <div class="step">
      <div class="number">1</div>
      <div class="text">
        下载并安装适配电脑版本的安装包，完成后打开爆米花进行注册。
      </div>
    </div>
    <div class="img">
      <img
        src="../../../../assets/images/popcorn/fifth-part-11.png"
        [width]="679"
        height="auto"
        alt=""
        style="margin-left: 30px"
      />
    </div>
  </div>
  <div class="card">
    <div class="img">
      <img
        src="../../../../assets/images/popcorn/fifth-part-21.png"
        [width]="679"
        height="auto"
        alt=""
        style="margin-right: 30px"
      />
    </div>
    <div class="step">
      <div class="number">2</div>
      <div class="text">
        点击头像，选择“我的兑换”，然后点击左上角的“我要兑换”按钮。将您购买的兑换码粘贴至输入框中，点击“立即兑换”完成操作。
      </div>
    </div>
  </div>
  <div class="card">
    <div class="step">
      <div class="number">3</div>
      <div class="text">
        点击左上角的爆米花
        logo，返回首页。在首页选择已兑换服务的对应平台，点击“开始播放”即可畅享观影之旅！
      </div>
    </div>
    <div class="img">
      <img
        src="../../../../assets/images/popcorn/fifth-part-31.png"
        [width]="679"
        height="auto"
        alt=""
        style="margin-left: 30px"
      />
    </div>
  </div>
</div>
<div class="button">
  <button routerLink="/popcorn">产品介绍</button>
</div>
